import { useThreadListRowKebabMenuModel } from './useThreadListRowKebabMenuModel.js'
import ThreadListRowKebabMenuView from './ThreadListRowKebabMenuView.jsx'

export default function ThreadListRowKebabMenu(props) {
  const model = useThreadListRowKebabMenuModel(props)
  return <ThreadListRowKebabMenuView {...props} {...model} />
}
